import React, { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntity, deleteEntity } from './aidas-user-aidas-object-mapping.reducer';

export const AidasUserAidasObjectMappingDeleteDialog = (props: RouteComponentProps<{ id: string }>) => {
  const [loadModal, setLoadModal] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
    setLoadModal(true);
  }, []);

  const aidasUserAidasObjectMappingEntity = useAppSelector(state => state.aidasUserAidasObjectMapping.entity);
  const updateSuccess = useAppSelector(state => state.aidasUserAidasObjectMapping.updateSuccess);

  const handleClose = () => {
    props.history.push('/aidas-user-aidas-object-mapping' + props.location.search);
  };

  useEffect(() => {
    if (updateSuccess && loadModal) {
      handleClose();
      setLoadModal(false);
    }
  }, [updateSuccess]);

  const confirmDelete = () => {
    dispatch(deleteEntity(aidasUserAidasObjectMappingEntity.id));
  };

  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose} data-cy="aidasUserAidasObjectMappingDeleteDialogHeading">
        Confirm delete operation
      </ModalHeader>
      <ModalBody id="ainnotategwApp.ainnotateserviceAidasUserAidasObjectMapping.delete.question">
        Are you sure you want to delete this AidasUserAidasObjectMapping?
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp; Cancel
        </Button>
        <Button
          id="jhi-confirm-delete-aidasUserAidasObjectMapping"
          data-cy="entityConfirmDeleteButton"
          color="danger"
          onClick={confirmDelete}
        >
          <FontAwesomeIcon icon="trash" />
          &nbsp; Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AidasUserAidasObjectMappingDeleteDialog;
